import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import {
  CLEAR_CABIN_CREW_MOVEMENT_HISTORY,
  CLEAR_CABIN_CREW_MOVEMENT_HISTORY_LIST,
  FLAG_CABIN_CREW_MOVEMENT_HISTORY_ACTIVITY,
  FLAG_GETTING_CABIN_CREW_MOVEMENT_HISTORY,
  GET_CABIN_CREW_MOVEMENT_HISTORY,
  GET_CABIN_CREW_MOVEMENT_HISTORY_LIST,
  POST_CABIN_CREW_MOVEMENT_HISTORY,
  PUT_CABIN_CREW_MOVEMENT_HISTORY,
} from '../types';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  DEFAULT_DELETE_CONFIG,
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import { CABIN_CREW_MOVEMENT_HISTORY_PATH } from '../../config/paths';
import { tzNormalizeDate } from '../../utils/date';
import { DATE_TIME_FORMAT } from '../../config/locale';
import { CABIN_CREW_MOVEMENT_HISTORY_ENDPOINT } from '../../config/endpoints';

const flagGettingCabinCrewMovementHistory = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_CABIN_CREW_MOVEMENT_HISTORY,
    payload: flag,
  });

const getCabinCrewsMovementHistory = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingCabinCrewMovementHistory(true));
    const query = tableFilters;
    const url = `${CABIN_CREW_MOVEMENT_HISTORY_ENDPOINT}?${QueryString.stringify(
      query,
    )}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const cabinCrewList = await response.json();
    dispatch({
      type: GET_CABIN_CREW_MOVEMENT_HISTORY_LIST,
      payload: cabinCrewList,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingCabinCrewMovementHistory(false));
  }
};

const clearCabinCrewsMovementHistory = () => (dispatch) =>
  dispatch({
    type: CLEAR_CABIN_CREW_MOVEMENT_HISTORY_LIST,
  });

const flagCabinCrewMovementHistoryActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_CABIN_CREW_MOVEMENT_HISTORY_ACTIVITY,
    payload: flag,
  });

const clearCabinCrewMovementHistory = () => (dispatch) =>
  dispatch({
    type: CLEAR_CABIN_CREW_MOVEMENT_HISTORY,
  });

const getCabinCrewMovementHistory =
  async ({ cabinCrewMovementHistoryId }) =>
    async (dispatch) => {
      try {
        dispatch(flagCabinCrewMovementHistoryActivity(true));
        const url = `${CABIN_CREW_MOVEMENT_HISTORY_ENDPOINT}/${cabinCrewMovementHistoryId}`;
        const response = await fetch(url, DEFAULT_GET_CONFIG);
        await isErrorResponse(response, null, dispatch);
        const cabinCrewMovementHistory = await response.json();
        dispatch({
          type: GET_CABIN_CREW_MOVEMENT_HISTORY,
          payload: cabinCrewMovementHistory,
        });
      } catch ({ message }) {
        toastr.error('Error', message);
      } finally {
        dispatch(flagCabinCrewMovementHistoryActivity(false));
      }
    };

const postCabinCrewMovementHistory =
  async ({
    startDate,
    endDate,
    cabinCrew: { value: cabinCrewId },
    driverMovement: { value: cabinCrewMovementId },
    note,
    secondaryNote,
    chargeMonth,
    chargeYear,
    redirect = true
  }) =>
    async (dispatch) => {
      try {
        dispatch(flagCabinCrewMovementHistoryActivity(true));
        const payload = {
          startDate,
          endDate,
          cabinCrewId,
          cabinCrewMovementId,
          note,
          secondaryNote,
          chargeMonth,
          chargeYear
        };
        const response = await fetch(CABIN_CREW_MOVEMENT_HISTORY_ENDPOINT, {
          ...DEFAULT_POST_CONFIG,
          body: JSON.stringify(payload),
        });
        await isErrorResponse(response, null, dispatch);
        const cabinCrewMovementConflicts = await response.json();

        dispatch({
          type: POST_CABIN_CREW_MOVEMENT_HISTORY,
          payload: cabinCrewMovementConflicts,
        });

        const cabinCrewMovement = cabinCrewMovementConflicts.find(
          (item) => item.isConflicted === false,
        );

        if (cabinCrewMovement && redirect) {
          dispatch(push(`${CABIN_CREW_MOVEMENT_HISTORY_PATH}/${cabinCrewMovement.id}`));
          return;
        }

        cabinCrewMovementConflicts
          .filter((movement) => movement.isConflicted)
          .forEach((movement) => {
            toastr.warning(
              'Movimiento en conflicto',
              `No se pudo registrar el Movimiento debido que está en: ${movement.name
              } desde ${tzNormalizeDate({
                date: movement.startDate,
                format: DATE_TIME_FORMAT,
              })} hasta ${tzNormalizeDate({
                date: movement.endDate,
                format: DATE_TIME_FORMAT,
              })}`,
              {
                removeOnHover: false,
                timeOut: 0,
                showCloseButton: true,
              },
            );
          });
      } catch ({ message }) {
        toastr.error('Error', message);
      } finally {
        dispatch(flagCabinCrewMovementHistoryActivity(false));
      }
    };


const putCabinCrewMovementHistory =
  async (cabinCrewMovementHistoryId, { startDate,
    endDate,
    driverMovement: { value: cabinCrewMovementId },
    note,
    cabinCrew: { value: cabinCrewId },
    secondaryNote,
    chargeMonth,
    chargeYear }) =>
    async (dispatch) => {
      try {
        dispatch(flagCabinCrewMovementHistoryActivity(true));
        const payload = {
          note,
          secondaryNote,
          startDate,
          endDate,
          cabinCrewMovementId,
          chargeMonth,
          chargeYear,
          cabinCrewId,
        };
        const url = `${CABIN_CREW_MOVEMENT_HISTORY_ENDPOINT}/${cabinCrewMovementHistoryId}`;
        const response = await fetch(url, {
          ...DEFAULT_PUT_CONFIG,
          body: JSON.stringify(payload),
        });
        await isErrorResponse(response, null, dispatch);
        const cabinCrewMovement = await response.json();

        dispatch({
          type: PUT_CABIN_CREW_MOVEMENT_HISTORY,
          payload: cabinCrewMovement,
        });

        dispatch(push(`${CABIN_CREW_MOVEMENT_HISTORY_PATH}/${cabinCrewMovement.id}`));
      } catch ({ message }) {
        toastr.error('Error', message);
      } finally {
        dispatch(flagCabinCrewMovementHistoryActivity(false));
      }
    };

// const getPrintCabinCrewMovementHistory =
//   async (formValues) => async (dispatch) => {
//     try {
//       dispatch(flagGettingCabinCrewMovementHistory(true));
//       const url = `${CABIN_CREW_ACTIVITY_ENDPOINT}/export-file?${QueryString.stringify(
//         formValues,
//       )}`;
//       const response = await fetch(url, {
//         ...DEFAULT_GET_CONFIG,
//       });
//       await isErrorResponse(response, null, dispatch);
//       const blob = await response.blob();
//       const downloadUrl = URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = downloadUrl;
//       link.download = 'Tareo.xlsx';
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//     } catch (error) {
//       toastr.error('Error', error.message);
//     } finally {
//       dispatch(flagGettingCabinCrewMovementHistory(false));
//     }
//   };

const deleteCabinCrewMovementHistory = (cabinCrewMovementHistoryId) => async (dispatch) => {
  try {
    dispatch(flagCabinCrewMovementHistoryActivity(true));
    const url = `${CABIN_CREW_MOVEMENT_HISTORY_ENDPOINT}/${cabinCrewMovementHistoryId}`;
    const response = await fetch(url, {
      method: 'DELETE',
      ...DEFAULT_DELETE_CONFIG,
    });
    await isErrorResponse(response, null, dispatch);
    dispatch(push(CABIN_CREW_MOVEMENT_HISTORY_PATH));
    toastr.success('Éxito', 'El registro de movimiento del tripulante ha sido eliminado.');
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagCabinCrewMovementHistoryActivity(false));
  }
};

export {
  flagGettingCabinCrewMovementHistory,
  getCabinCrewsMovementHistory,
  clearCabinCrewsMovementHistory,
  flagCabinCrewMovementHistoryActivity,
  clearCabinCrewMovementHistory,
  getCabinCrewMovementHistory,
  postCabinCrewMovementHistory,
  // getPrintCabinCrewMovementHistory,
  putCabinCrewMovementHistory,
  deleteCabinCrewMovementHistory
};